import React, { useEffect, useMemo, useState } from 'react';
import TableColumnFilter from 'components/elements/organisms/TableColumnFilter/TableColumnFilter';

const atRiskOptions = [
  { label: 'All', value: '' },
  { label: 'Within a day', value: 'lt1' },
  { label: '1 to 3 days ago', value: '1to3' },
  { label: '3 to 7 days ago', value: '3to7' },
  { label: '7+ days ago', value: 'gt7' },
];

export default function DailyCheckInHeader({
  filters,
  setFilters,
  setPage,
  actions,
}) {
  const [browsers, setBrowsers] = useState([]);
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    async function init() {
      const extensionMeta = await actions.getDistinctExtensionMeta();

      setBrowsers(extensionMeta.browsers || []);
      setDevices(extensionMeta.devices || []);
    }
    init();
  }, []);

  const browserOptions = useMemo(() => {
    const sorted = [...browsers].sort((a, b) => a.localeCompare(b));
    return [
      { label: 'All Browsers', value: '' },
      ...sorted.map((c) => ({ label: c, value: c })),
    ];
  }, [browsers]);

  const deviceOptions = useMemo(() => {
    const sorted = [...devices].sort((a, b) => a.localeCompare(b));
    return [
      { label: 'All Devices', value: '' },
      ...sorted.map((c) => ({ label: c, value: c })),
    ];
  }, [devices]);

  return (
    <tr>
      <th></th>
      <th>Name</th>
      <th>Email</th>
      {/* <th>Schools</th> */}
      <th className="text-center">
        Logged In{' '}
        <TableColumnFilter
          options={[
            { label: 'All', value: '' },
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
          onChange={(isLoggedIn) => setFilters((f) => ({ ...f, isLoggedIn }))}
          value={filters.isLoggedIn}
        />
      </th>
      <th className="text-center">
        Pinned{' '}
        <TableColumnFilter
          options={[
            { label: 'All', value: '' },
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
          onChange={(isPinned) => setFilters((f) => ({ ...f, isPinned }))}
          value={filters.isPinned}
        />
      </th>
      <th className="text-center">
        Last Check-In{' '}
        <TableColumnFilter
          options={atRiskOptions}
          onChange={(atRisk) => {
            console.log('atRisk', atRisk);
            if (atRisk.find((atRisk) => atRisk === '')) {
              setPage(1);
              setFilters({ ...filters, atRisk: [] });
              return;
            }

            setPage(1);
            setFilters({ ...filters, atRisk });
          }}
          value={filters.atRisk}
          allowSearch
          single={false}
        />
      </th>
      <th className="text-center">
        Device{' '}
        <TableColumnFilter
          options={deviceOptions}
          onChange={(device) => setFilters((f) => ({ ...f, device }))}
          value={filters.device}
          allowSearch
        />
      </th>
      <th className="text-center">
        Browser{' '}
        <TableColumnFilter
          options={browserOptions}
          onChange={(browser) => setFilters((f) => ({ ...f, browser }))}
          value={filters.browser}
          allowSearch
        />
      </th>
      <th className="text-center">Version</th>
    </tr>
  );
}
